<template>
    <div class="detailIndex" v-loading="dataLoading">
        <!--答疑顶部-->
        <div class="showBox wrapView">
            <!--左数据详情-->
            <div class="showLeft">
                <div class="dataTitle" v-html="dataObj.title"></div>
                <div class="dataInfo">
                    <div class="dataInfoLeft" v-if="dataObj.author&&dataObj.author!=''">来源: <span>{{ dataObj.author }}</span> </div>
                    <div class="dataInfoRight">日期:{{ dataObj.publishDate }}</div>
                </div>
                <div class="dataContent" v-if="dataObj.attribute" v-html="dataObj.attribute.text"></div>
                <div class="vipText" v-if="$store.state.user.vipInfo.isVip != 1">
                    ------------以下内容省略若干行,请<span @click="vipFun">续费VIP</span>后查看------------
                </div>
            </div>
            <!--右侧相关-->
            <div class="showRight">
                <div class="rightTop">相关答疑</div>
                <div class="rightDataBox">
                    <div 
                        class="rightList" 
                        v-for="(item,index) in rightDYData" 
                        :key="index" 
                        @click="goDetail(item)">
                        <span style="font-size:16px;color:#0D5BC2;">{{ index + 1 }}.</span>
                        <span v-html="item.title"></span>
                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <bottomNav />
    </div>
</template>
<script>

// //引入接口
// import { doRequest } from "@/request/index.js"

//引入接口
import { getDaYiData } from '@/api/importZSG/api.js'
import { dayiDetail } from '@/api/api.js'


export default {
    name:'detail',
    components:{

    },
    data(){
        return{
            dataLoading:false,
            id:'',
            type:'',
            searchData:{},
            dataObj:{},
            //右侧相关答疑
            rightDYData:[],
        }
    },
    created(){
        let options = this.$route.query;
        this.id = options.id
        this.type = options.type;
        this.searchData = JSON.parse(options.searchData);
        //获取详情
        this.getDetail()
        //根据类型获取相关答疑
        this.dayiData(this.searchData);
    },
    methods:{
        vipFun(){
            window.open('http://zsdy-mall-pc.bjzsdy.com/goodsType?appCode=taxlaw', "_blank");
        },
        //获取详情
        getDetail(){
            let send_data = {
                id:this.id
            };
            if(this.searchData['keyword']&&this.searchData['keyword']!=''){
                send_data['keyword'] = this.searchData['keyword']
            }
            if(this.searchData['categoryId']&&this.searchData['categoryId']!=''){
                send_data['categoryId'] = this.searchData['categoryId']
            }
            this.dataLoading = true;
            dayiDetail(send_data).then(res => {
                if(res.status == 200&&res.data.status == 0){
                    this.dataObj = res.data.rows[0];
                    //添加到缓存中
                    //this.getAddSession(this.dataObj);
                }else{
                    this.$message({
                        message:'详情获取失败',
                    })
                }
                /* debugger
                 this.dataObj = res.data.rows[0];
                    //添加到缓存中
                    this.getAddSession(this.dataObj);
                    */
                this.dataLoading = false;
            }).catch(err => {
                this.$message({
                    message:'详情获取失败',
                })
                this.dataLoading = false;
                console.log(err)
            })
        },
        //获取相关答疑
        dayiData(data){
            let send_data = data;
            getDaYiData(send_data).then(res => {
                if(res.status ==200&&res.data.status == 0){
                    let tRes = res.data.rows;
                    for(let a=0;a<tRes.length;a++){
                        if(tRes[a].id == this.id){
                            tRes.splice(a,1)
                            tRes = tRes
                        }
                    }
                    //判断条数
                    if(tRes.length>5){
                        this.rightDYData = tRes.slice(0,5)
                    }else{
                        this.rightDYData = tRes
                    }
                }
            }).catch(err => {
                this.$message({
                    message:'答疑数据获取失败',
                    type:'warning'
                })
                console.log(err)
            })
        },
        //查看详情
        goDetail(item){
            let sObj = JSON.stringify(this.searchData)
            let routeData = this.$router.resolve({
                path:'contentDY',
                query:{
                    id:item.id,
                    type:this.type,
                    searchData:sObj
                }
            })
            window.open(routeData.href,"_blank")
        },
        //存储到缓存中
        getAddSession(item){
            //定义个要保存的数据的对象
            let newObj = {}
            newObj['id'] = this.id;
            newObj['title'] = encodeURIComponent(item.title);//encodeURIComponent(encodeURIComponent(item.title));
            newObj['type'] = this.type;
            newObj['searchData'] = this.searchData;

            //获取时间
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            if(month<10)month="0" + month
            let dates = date.getDate();
            if(dates<10)month="0" + dates
            newObj['time'] = '' + year + '-' + month + '-' + dates;

            //获取session缓存
            let thatSession = localStorage.getItem('sessionHistoryDataDYK');
            if(thatSession===null){
                let setArr = []
                setArr.push(newObj)
                localStorage.setItem('sessionHistoryDataDYK',JSON.stringify(setArr));
            }else{
                //解析数据
                let sessionList = JSON.parse(thatSession);
                //判断id是否存在
                for(let i=(sessionList.length - 1);i>-1;i--){
                    if(sessionList[i].id == this.id){
                        //如果存在就删除这个索引的数据
                        sessionList.splice(i,1);
                    }
                }
                //判断数组是否超过20 超过20就截取一下
                if(sessionList.length>=20){
                    sessionList =   sessionList.slice(0,19);
                }
                //将当前条数据存进去
                sessionList.unshift(newObj)
                localStorage.setItem('sessionHistoryDataDYK',JSON.stringify(sessionList));
            }
        },

    }
}
</script>
<style scoped lang="scss">
    .wrapView{
        width: 1200px;
        margin:0 auto;
    }
    .showBox{
        overflow: hidden;
        margin-top: 20px;
        padding-bottom:20px;
        .showLeft{
            width: 840px;
            overflow: hidden;
            float:left;
            background: #FFFFFF;
            box-sizing: border-box;
            padding:45px;
            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
            .dataTitle{
                width:100%;
                font-family: SourceHanSansCN-Bold;
                font-size: 18px;
                font-weight: bold;
                line-height: 36px;
                letter-spacing: 0em;
                color: #3D3D3D;
            }
            .dataInfo{
                width:100%;
                height:60px;
                line-height: 60px;
                border-bottom:2px solid #D0D0D0;
                .dataInfoLeft{
                    display: inline-block;
                }
                .dataInfoRight{
                    display: inline-block;
                    margin-left:40px;
                }
            }
            .dataContent{
                padding-top:25px;
            }
            .dataContent ::v-deep p{
                font-family: SourceHanSansCN-Bold;
                font-size: 16px;
                /*font-weight: bold;*/
                line-height: 30px;
                letter-spacing: 0em;
                color: #3D3D3D;
            }
        }
        .showRight{
            width: 350px;
            height: 480px;
            float:left;
            margin-left:10px;
            background: #FFFFFF;
            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
            .rightTop{
                width: 350px;
                height: 44px;
                line-height: 44px;
                background: #0D5BC2;
                box-sizing: border-box;
                padding-left:30px;
                color:#ffffff;
            }
            .rightDataBox{
                box-sizing: border-box;
                padding:18px 30px;
                .rightList{
                    height: 70px;
                    font-family: SourceHanSansCN-Regular;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 32px;
                    letter-spacing: 0em;
                    margin-bottom:10px;
                    cursor:pointer;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
    .detailIndex ::v-deep .dyNav{
        margin-top:0!important;
    }
    .vipText{
        margin-top: 25px;
        font-family: SourceHansansCN-Normal;
        font-size: 16px;
        text-align: center;
        color: #e62d2d;
        span{
            color: #2771e2!important;
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>